import { render, staticRenderFns } from "./NoteSection.vue?vue&type=template&id=26f28bc4&scoped=true&"
import script from "./NoteSection.vue?vue&type=script&lang=ts&"
export * from "./NoteSection.vue?vue&type=script&lang=ts&"
import style0 from "./NoteSection.vue?vue&type=style&index=0&id=26f28bc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f28bc4",
  null
  
)

export default component.exports